<template>
	<div class="centerx" ref="popupContainer">
		<ProspectionDetailsCard
			:detail="prospectProjectDetails"
			class="mb-3"
			:key="prospectionDetailKey"
		/>
		<div
			style="display: flex; justify-content: space-between; align-items: center"
		>
			<vx-tooltip text="Actualiser l'affichage" position="top">
				<vs-button
					size="large"
					type="flat"
					icon-pack="feather"
					icon="icon-refresh-cw"
					@click="refreshData()"
				></vs-button>
			</vx-tooltip>

			<div class="flex justify-end items-center mb-3 space-x-4">
				<div class="flex items-center">
					<div class="mr-2">Dernière mise à jour:</div>
					<div>
						{{
							prospectsList.length > 0
								? getDateToFrenchFormat(
										prospectsList[0].updated_date || new Date()
								  )
								: ""
						}}
					</div>
				</div>
				<vs-button
					@click="exportToExcel(prospectsList)"
					ref="exportButton"
					id="button-with-loading"
					type="relief"
					vslor="primary"
					class="vs-con-loading__container"
				>
					Exporter
				</vs-button>
			</div>
		</div>

		<div class="flex flex-col">
			<div v-if="isLoading" class="flex justify-center items-center">
				<circular-loader></circular-loader>
			</div>
			<div v-else>
				<ag-grid-vue
					:key="prospectsListKey"
					:columnDefs="columnDefs"
					:rowData="prospectsList"
					class="ag-theme-balham"
					dom-layout="autoHeight"
					:defaultColDef="defaultColDef"
					:gridOptions="gridOptions"
				></ag-grid-vue>
				<div v-if="bottomPageLoading" class="flex justify-center items-center">
					<circular-loader></circular-loader>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import store from "@/store/store";
import Vue from "vue";
import XLSX from "xlsx";
import { AgGridVue } from "ag-grid-vue";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
import ProspectionDetailsCard from "../../../components/views/dashboard/prospection/ProspectionDetailsCard.vue";
import VxTooltip from "../../../components/widgets/vx-tooltip/VxTooltip.vue";
import SFIssuesDetailsPopUp from "../../../components/views/dashboard/prospection/SFIssuesDetailsPopUp.vue";
import PropsectTechnologyPopup from "../../../components/views/dashboard/prospection/ProspectTechnologyPopup.vue";
import SFInternalTabsDetailsPopup from "../../../components/views/dashboard/prospection/SFInternalTabsDetailsPopup.vue";
import ProspectRadarChartPopup from "../../../components/views/dashboard/prospection/ProspectRadarChartPopup.vue";
import ProspectGTMetrixPopup from "../../../components/views/dashboard/prospection/ProspectGTMetrixPopup.vue";
import CircularLoader from "../../../components/widgets/loader/CircularLoader.vue";
import LinkedinInfoPopup from "../../../components/views/dashboard/prospection/LinkedinInfoPopup.vue";
import DescColorChipRenderer from "../../../components/views/dashboard/prospection/cellRenderer/DescColorChipRenderer.vue";
import GTMetrixRenderer from "../../../components/views/dashboard/prospection/cellRenderer/GTMetrixRenderer.vue";
import DisplayNoteSeoRenderer from "../../../components/views/dashboard/prospection/cellRenderer/DisplayNoteSeoRenderer.vue";
import TechnologyRenderer from "../../../components/views/dashboard/prospection/cellRenderer/TechnologyRenderer.vue";
import EcommerceRenderer from "../../../components/views/dashboard/prospection/cellRenderer/EcommerceRenderer.vue";
import LinkedinUrlRenderer from "../../../components/views/dashboard/prospection/cellRenderer/LinkedinUrlRenderer.vue";
import ContactLinkedinRenderer from "../../../components/views/dashboard/prospection/cellRenderer/ContactLinkedinRenderer.vue";
import EditLinkedinRenderer from "../../../components/views/dashboard/prospection/cellRenderer/EditLinkedinRenderer.vue";
import RankAbsoluteRenderer from "../../../components/views/dashboard/prospection/cellRenderer/RankAbsoluteRenderer.vue";
import UrlDisplayedRenderer from "../../../components/views/dashboard/prospection/cellRenderer/UrlDisplayedRenderer.vue";
import IssuesRenderer from "../../../components/views/dashboard/prospection/cellRenderer/IssuesRenderer.vue";
import KeywordsHeaderRenderer from "../../../components/views/dashboard/prospection/cellRenderer/KeywordsHeaderRenderer.vue";
import SimpleRenderer from "../../../components/views/dashboard/prospection/cellRenderer/SimpleRenderer.vue";
import CmsRenderer from "../../../components/views/dashboard/prospection/cellRenderer/CmsRenderer.vue";
import GoogleServiceRenderer from "../../../components/views/dashboard/prospection/cellRenderer/GoogleServiceRenderer.vue";
import HeaderRenderer from "../../../components/views/dashboard/prospection/cellRenderer/HeaderRenderer.vue";

// import ProspectCustomCellRenderer from "./ProspectCustomCellRenderer.vue";
export default {
	data() {
		return {
			// Store complete column definitions
			completeColumnDefs: null,

			// Your data properties here
			prospectProjectDetails: {},
			prospectsList: [],
			maxItems: 200,
			totalPage: 0,
			currentPage: 1,
			prospectsListKey: 0,
			prospectionDetailKey: 0,
			keywordsHeader: [],
			backgroundLoading: "primary",
			colorLoading: "#fff",
			isLoading: false,
			bottomPageLoading: false,

			// Table data
			columnDefs: [
				{
					headerName: `Url`,
					field: "url",
					pinned: "left", // Fix this column on the left side
					valueGetter: (p) => new URL(p.data.url).host.replace("www.", ""),
					// Use cellRenderer to make the link clickable if needed
					cellRenderer: (params) => {
						return `<a href="https://${params.value}" target="_blank">${params.value}</a>`;
					},
				},
				{
					// headerComponentFramework: "HeaderRenderer", // Use your custom component
					headerClass: "center-header",
					width: 120,
					headerName: "SEO",
					field: "seo",
					pinned: "left", // Fix this column on the left side
					// width: 150,
					// type: "numericColumn",
					cellRendererFramework: "DisplayNoteSeoRenderer",
					cellStyle: {
						textAlign: "center", // Horizontal centering
						verticalAlign: "middle", // Vertical centering
					}, // Reference the custom component
				},
				{
					headerComponentFramework: "HeaderRenderer", // Use your custom component
					headerClass: "center-header",
					width: 150,
					headerName: "Traffic",
					pinned: "left",
					field: "ahrefs.search_traffic",
					// width: 120,
					type: "numericColumn",
					valueFormatter: (params) => params.value,
					cellRendererFramework: "SimpleRenderer", // Use the Vue component
					cellRendererParams: {
						// You can pass params explicitly if needed
						valueGetter: (params) => params.value, // Pass the value directly to the component
					},
					cellStyle: {
						textAlign: "right", // Horizontal centering
						verticalAlign: "middle", // Vertical centering
					},
				},
				{
					headerName: "Netlink",
					headerClass: "netlink-header ",
					suppressStickyLabel: true,
					children: [
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							width: 120,
							headerName: `Domain Rating`,
							field: "ahrefs.domain_rating",

							headerClass: "netlink-header",
							type: "numericColumn",
							cellRendererFramework: "DescColorChipRenderer", // Use the Vue component
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value, // Pass the value directly to the component
							},
							cellStyle: {
								textAlign: "right", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
						},
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "netlink-header ",
							width: 120,
							headerName: "NB Liens entrants",
							field: "ahrefs.reffering_page",
							// width: 150,
							type: "numericColumn",
							valueFormatter: (params) => params.value,
							cellRendererFramework: "SimpleRenderer", // Use the Vue component
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value, // Pass the value directly to the component
							},
							cellStyle: {
								textAlign: "right", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
						},
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "netlink-header",
							width: 150,
							headerName: "NB Domaines référents",
							field: "ahrefs.reffering_domain",
							// width: 120,
							type: "numericColumn",
							valueFormatter: (params) => params.value,
							cellRendererFramework: "SimpleRenderer", // Use the Vue component
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value, // Pass the value directly to the component
							},
							cellStyle: {
								textAlign: "right", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
						},
					],
				},
				{
					headerName: "Keywords",
					headerClass: "seprator-header keywords-header",
					suppressStickyLabel: true,
					children: [
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "keywords-header seprator-small-header",
							width: 150,
							headerName: "Mots clés",
							field: "ahrefs.keyword",
							// width: 120,
							type: "numericColumn",
							valueFormatter: (params) => params.value,
							cellRendererFramework: "SimpleRenderer", // Use the Vue component
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value, // Pass the value directly to the component
							},
							cellStyle: {
								textAlign: "right", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
						},
					],
				},
				{
					headerName: "Technique",
					headerClass: "indexation-header seprator-header",
					suppressStickyLabel: true,
					children: [
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "indexation-header  seprator-small-header",
							width: 160,
							headerName: "Indexation (SiteMap/ Google Index)",
							field: "urls_displayed",
							// width: 150,
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
							cellRendererFramework: "UrlDisplayedRenderer",
							tooltipValueGetter: (params) => {
								try {
									const value = params.data
										? Number(params.data.urls_displayed).toLocaleString(
												"fr-FR"
										  ) +
										  " / " +
										  Number(params.data.google_indexable_urls).toLocaleString(
												"fr-FR"
										  )
										: 0;
									return value || 0;
								} catch (e) {
									return 0;
								}
							}, // Use the Vue component
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value, // Pass the value directly to the component
							},

							// type: "numericColumn",
						},
						{
							headerName: "Issues",
							headerClass: "indexation-header  ",
							field: "lowIssues",
							width: 150,
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
							valueFormatter: (p) => p.data.totalIssues,
							// cellRendererFramework: "IssuesRenderer", // Use the Vue component
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value, // Pass the value directly to the component
							},

							// type: "numericColumn",
						},
						{
							headerName: "Faible | Moyenne | Élevée",
							headerClass: "indexation-header  ",
							field: "lowIssues",
							width: 150,
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
							valueFormatter: (p) =>
								p.data.lowIssues +
								" | " +
								p.data.mediumIssues +
								" | " +
								p.data.highIssues,
							cellRendererFramework: "IssuesRenderer", // Use the Vue component
							tooltipValueGetter: (params) => {
								return "Issues";
							},
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value, // Pass the value directly to the component
							},

							// type: "numericColumn",
						},
					],
				},
				{
					headerName: "Web Perfs",
					suppressStickyLabel: true,
					headerClass: "webprefs-header seprator-header",
					children: [
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "webprefs-header seprator-small-header",
							width: 120,
							headerName: "Lighthouse Perf.",
							field: "performance",
							// width: 150,
							cellRendererFramework: "DescColorChipRenderer", // Use the Vue component
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value,
								toPercent: true, // Pass the value directly to the component
							},
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
						},
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "webprefs-header",
							width: 120,
							headerName: "Lighthouse SEO",
							field: "seo",
							// width: 150,
							cellRendererFramework: "DescColorChipRenderer", // Use the Vue component
							// valueGetter: (params) => params.value,
							cellRendererParams: {
								// You can pass params explicitly if needed
								valueGetter: (params) => params.value,
								toPercent: true, // Pass the value directly to the component
							},
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
						},
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "webprefs-header ",
							width: 120,
							headerName: "GT Metrix",
							field: "gtMetrix",
							// width: 150,
							cellRendererFramework: "GTMetrixRenderer",
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
						},
					],
				},
				{
					headerName: "Technologies",
					suppressStickyLabel: true,
					headerClass: "tech-header seprator-header",
					children: [
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "tech-header seprator-small-header",
							width: 120,
							headerName: "CMS",
							field: "technologies",
							// width: 150,
							cellRendererFramework: "CmsRenderer",
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},

							tooltipValueGetter: (params) => {
								try {
									const cmsName = JSON.parse(
										params.data.technologies[0].services
									).cms.name;
									return cmsName || "-"; // Show cmsName if it exists, else "-"
								} catch (error) {
									return "-"; // Show "-" on error (invalid JSON, undefined values)
								}
							}, //
						},

						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "tech-header ",
							width: 130,
							headerName: "Google Services",
							field: "technologies",
							// width: 150,
							cellRendererFramework: "GoogleServiceRenderer",
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
						},
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "tech-header ",
							width: 120,
							headerName: "E-commerce",
							field: "is_ecommerce",
							// width: 150,
							cellRendererFramework: "EcommerceRenderer",
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							},
							// Reference the custom component
							// type: "numericColumn",
						},
					],
				},
				{
					headerName: "Linkedin",
					suppressStickyLabel: true,
					headerClass: "others-header seprator-header",
					children: [
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "others-header seprator-small-header",
							width: 120,
							headerName: "Linkedin",
							field: "linkedin_url",
							// width: 150,
							cellRendererFramework: "LinkedinUrlRenderer",
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							}, // Reference the custom component
							// type: "numericColumn",
							tooltipField: "linkedin_url", // Uses AG Grid's tooltip
						},
						{
							headerComponentFramework: "HeaderRenderer", // Use your custom component
							headerClass: "others-header ",
							width: 120,
							headerName: "Contacts Linkedin",
							field: "linkedin_url",
							// width: 150,
							cellRendererFramework: "ContactLinkedinRenderer",
							cellStyle: {
								textAlign: "center", // Horizontal centering
								verticalAlign: "middle", // Vertical centering
							}, // Reference the custom component

							// type: "numericColumn",
						},
					],
				},
				{
					headerName: "Action",
					headerClass: "others-header",
					width: 100,
					field: "id",
					cellRendererFramework: "EditLinkedinRenderer",
					cellStyle: {
						textAlign: "center",
						verticalAlign: "middle",
					},
				},
			],

			// Default column settings
			defaultColDef: {
				initialWidth: 200,
				initalHeight: 100,
				wrapHeaderText: true,
				autoHeaderHeight: true,
				sortable: true,
				resizable: true,
			},
			// Grid options
			gridOptions: {
				rowHeight: 60,
				headerHeight: 100,
				groupHeaderHeight: 60,
				enableBrowserResizeObserver: true,
				tooltipShowDelay: 0,
				tooltipHideDelay: 200,
			},
		};
	},
	components: {
		AgGridVue,
		ProspectionDetailsCard,
		VxTooltip,
		SFIssuesDetailsPopUp,
		PropsectTechnologyPopup,
		SFInternalTabsDetailsPopup,
		ProspectRadarChartPopup,
		ProspectGTMetrixPopup,
		CircularLoader,
		LinkedinInfoPopup,
		DescColorChipRenderer,
		GTMetrixRenderer,
		DisplayNoteSeoRenderer,
		TechnologyRenderer,
		EcommerceRenderer,
		LinkedinUrlRenderer,
		ContactLinkedinRenderer,
		EditLinkedinRenderer,
		RankAbsoluteRenderer,
		UrlDisplayedRenderer,
		IssuesRenderer,
		KeywordsHeaderRenderer,
		SimpleRenderer,
		CmsRenderer,
		GoogleServiceRenderer,
		HeaderRenderer,
		// ProspectCustomCellRenderer,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	created() {
		// Store complete column definitions
		this.completeColumnDefs = [...this.columnDefs];

		this.fetchProspectProjectDetails();
		this.fetchProspects();
		const fliterCard = document.getElementById("fliterCard");
		const fliterCardHeight = fliterCard ? fliterCard.clientHeight : 0;
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				fliterCardHeight -
				0.21 * this.windowHeigth
		);
		// this.addkeywordsHeaders();

		// this.displayIssuesDetails();
	},
	mounted() {
		// After grid is set up, try logging params from a grid API function
	},
	watch: {
		// currentPage: function (val) {
		// 	this.fetchProspects();
		// },
		// Your watch properties here
	},
	computed: {
		tableHeight: () => {
			return store.state.tableHeight;
		},
		// keywordsHeader () {
		// 	// Flatten all keywords from all prospects into a single array
		// 	const allKeywords = this.prospectsList.flatMap((prospect) =>
		// 		prospect.keywords.map((keyword) => keyword.keyword)
		// 	);
		// 	// Use Set to get unique keywords
		// 	const keywordsHeader  = [...new Set(allKeywords)];
		// 	console.log("dsads", keywordsHeader );
		// 	return keywordsHeader ;
		// },
	},
	methods: {
		/**
		 * Get column definitions based on project type
		 * @returns {Array} Column definitions array
		 */
		getColumnDefs() {
			// Always needed URL column
			const urlColumn = {
				headerName: "Url",
				field: "url",
				pinned: "left",
				valueGetter: (p) => new URL(p.data.url).host.replace("www.", ""),
				cellRenderer: (params) => {
					return `<a href="https://${params.value}" target="_blank">${params.value}</a>`;
				},
				width: 200,
			};

			// LinkedIn section (for type 3)
			const linkedinColumns = {
				headerName: "Linkedin",
				suppressStickyLabel: true,
				headerClass: "others-header seprator-header",
				children: [
					{
						headerComponentFramework: "HeaderRenderer",
						headerClass: "others-header seprator-small-header",
						width: 120,
						headerName: "Linkedin",
						field: "linkedin_url",
						cellRendererFramework: "LinkedinUrlRenderer",
						cellStyle: {
							textAlign: "center",
							verticalAlign: "middle",
						},
						tooltipField: "linkedin_url",
					},
					{
						headerComponentFramework: "HeaderRenderer",
						headerClass: "others-header",
						width: 120,
						headerName: "Contacts Linkedin",
						field: "linkedin_url",
						cellRendererFramework: "ContactLinkedinRenderer",
						cellStyle: {
							textAlign: "center",
							verticalAlign: "middle",
						},
					},
				],
			};

			// Action column with the LinkedIn URL edit button
			const actionColumn = {
				headerName: "Action",
				headerClass: "others-header",
				width: 100,
				field: "id",
				cellRendererFramework: "EditLinkedinRenderer",
				cellStyle: {
					textAlign: "center",
					verticalAlign: "middle",
				},
			};

			// If type is 3, return only URL and LinkedIn columns
			if (
				this.prospectProjectDetails &&
				this.prospectProjectDetails.type == 3
			) {
				console.log("Using LinkedIn-only column set for type 3 project");
				return [urlColumn, linkedinColumns, actionColumn];
			}

			// For all other types, return full column set (already defined in data())
			return this.completeColumnDefs;
		},

		/**
		 * Update column definitions when project details are fetched
		 */
		updateColumnDefs() {
			// Update columns based on project type
			this.columnDefs = this.getColumnDefs();

			// Force grid to refresh
			this.prospectsListKey++;
		},

		/**
		 * Add keywords headers to the table
		 */
		/**
		 * Add keywords headers to the table
		 */
		addkeywordsHeaders() {
			// Check if the prospectsList has data and keywords
			if (!this.prospectsList.length || !this.prospectsList[0].keywords) {
				console.log("No keywords data available");
				return;
			}

			// For type 3 projects, we don't need to add keyword headers
			if (
				this.prospectProjectDetails &&
				this.prospectProjectDetails.type == 3
			) {
				console.log("Type 3 project - skipping keyword headers");
				return;
			}

			const keywords = this.prospectsList[0].keywords;

			// Dynamically generate columns for each keyword
			const keywordColumns = keywords.map((keyword, index) => ({
				headerComponentFramework: "KeywordsHeaderRenderer",
				headerClass: `keywords-header`,
				headerComponentParams: {
					keywordObj: keyword,
				},
				field: `keywords[${index}].rank_absolute`,
				cellRendererFramework: "RankAbsoluteRenderer",
				cellStyle: {
					textAlign: "right",
					verticalAlign: "middle",
				},
				cellRendererParams: {
					value: keyword.rank_absolute,
					keywordName: keyword.keyword,
				},
				width: 130,
			}));

			// Find the Keywords column
			const keywordsColumn = this.columnDefs.find(
				(col) => col.headerName === "Keywords"
			);

			// Only proceed if the Keywords column exists
			if (keywordsColumn) {
				let previousChild = keywordsColumn.children;
				keywordsColumn.children = [...previousChild, ...keywordColumns];
			} else {
				console.log(
					"Keywords column not found - this is expected for type 3 projects"
				);
			}
		},
		/**
		 * Clear keywords headers from the table
		 */
		clearKeywordsHeaders() {
			this.columnDefs.splice(3, 1);
		},

		/**
		 * fetch the report
		 */
		fetchReport(url) {
			const apikey = "31c910b2ffc697029ab06287edc28efc"; // Replace with your username
			let config = {
				method: "get",
				maxBodyLength: Infinity,
				url: url,
				headers: {
					"Content-Type": "application/vnd.api+json",
				},
				auth: {
					username: apikey,
					password: "", // Leave the password field empty
				},
			};
			axios
				.request(config)
				.then((response) => {
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(response.blob);
					link.download = "report.pdf"; // You can change the filename
					link.click();
				})
				.catch((error) => console.error("Error:", error));
		},

		/**
		 * get the color
		 * @param {Number} val
		 */
		getGradColor(val) {
			if (val == 0) return "primary";
			else return this.gradientColor(val);
		},
		refreshData() {
			this.clearKeywordsHeaders();
			this.fetchProspectProjectDetails();
			this.fetchProspects();
		},
		/**handle pagination change */
		handleChangePage(page) {
			this.fetchProspects();
		},
		getData(data) {
			if (data == "loading") return "◔";
			else return "◔";
		},
		isNumber(val) {
			if (!isNaN(parseFloat(val)) && isFinite(val)) {
				return true; // It's a number
			} else return false;
		},
		getColor(performance) {
			if (this.isNumber(performance)) {
				if (performance > 0.7) {
					return "success";
				} else if (performance >= 0.4 && performance <= 0.7) {
					return "warning";
				} else {
					return "danger";
				}
			} else return "primary";
		},
		// Your methods here
		fetchProspectProjectDetails() {
			console.log("fetchProspectProjectDetails", this.$route.params.ppId);
			this.$http
				.get("/prospect/getProjectDetail/" + this.$route.params.ppId)
				.then(
					(response) => {
						this.prospectProjectDetails = response.data;
						// Update column definitions based on project type
						this.updateColumnDefs();
					},
					(response) => {
						this.apiErrorMsg = response.data.message;
					}
				);
		},
		/**Fetch prospects by project id */
		async fetchProspects() {
			this.isLoading = true;
			this.bottomPageLoading = true;
			let limit = 7;
			let offset = 1;

			try {
				let hasMoreData = true;

				while (hasMoreData) {
					const response = await this.$http.get(
						`/prospect/getByProjectId?id=${this.$route.params.ppId}&limit=${limit}&page=${offset}`
					);

					if (response.data.dataList.length > 0) {
						this.prospectsList = [
							...this.prospectsList,
							...response.data.dataList,
						];

						this.prospectProjectDetails["progressCompleted"] = Math.ceil(
							((response.data.projectDetail.keyCount -
								response.data.projectDetail.loadingCount) /
								response.data.projectDetail.keyCount) *
								100
						);
						if (offset == 1) {
							this.addkeywordsHeaders();
							this.isLoading = false;
						}
						// this.prospectionDetailKey++;
						// this.prospectsListKey++;

						offset += 1; // Manually increment offset for the next request
					} else {
						hasMoreData = false; // Stop fetching when no more data is available
					}
				}
			} catch (error) {
				console.log("Error: fetchAllProspects", error);
			} finally {
				this.isLoading = false;
				this.bottomPageLoading = false;
			}
		},
		getCpc(keyword) {
			try {
				let cpc = this.prospectsList[0].keywords.find(
					(k) => k.keyword === keyword
				).cpc;
				return `CPC: ${
					!isNaN(cpc)
						? this.convertInternationalNumberToFrenchCurrency(cpc)
						: cpc
				}`;
			} catch (e) {
				return "";
			}
		},
		getVolume(keyword) {
			try {
				return `Volume: ${Number(
					this.prospectsList[0].keywords.find((k) => k.keyword === keyword)
						.search_volume
				).toLocaleString("fr-FR")}`;
			} catch (e) {
				return "";
			}
		},
		getGtMEtrixColor(val) {
			let colNum = 1;
			if (val == "A") colNum = 1;
			else if (val == "B") colNum = 17;
			else if (val == "C") colNum = 33;
			else if (val == "D") colNum = 49;
			else if (val == "E") colNum = 65;
			else if (val == "F") colNum = 81;
			else if (val == "G") colNum = 97;
			else colNum = 99;
			return this.getGradColor(colNum);
		},

		/**Fetch prospects for exports */
		async fetchProspectsExports() {
			return new Promise((resolve, reject) => {
				this.$http
					.get(
						`/prospect/getByProjectId?id=${this.$route.params.ppId}&limit=${this.prospectProjectDetails.prospects_count}&page=1`
					)
					.then((response) => {
						resolve(response.data.dataList);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		/**Export to Excel */
		async exportToExcel() {
			this.setLoading(true, "exportButton");
			let data = await this.fetchProspectsExports();
			this.setLoading(false, "exportButton");
			let wb = XLSX.utils.book_new();
			let ws_name = "Prospects";
			let header = {
				header: [
					"project_name",
					"se_country",
					"se_language",
					"se",
					"url",
					"domain_authority",
					"external_links",
					"anomaly",
					"high_issues",
					"l_performance",
					"l_seo",
					"linkedin_url",
					"referring_domains",
					// "referring_links",
					// "trust_flow",
					// "ttf0_name",
					// "ttf0_value",
					// "ttf1_name",
					// "ttf1_value",
					// "ttf2_name",
					// "ttf2_value",
				],
				skipHeader: true,
				origin: -1,
			};
			//adding additonal keywords to report header
			header.header.splice(4, 0, ...this.keywordsHeader);
			let keywordHeaderObj = {};
			this.keywordsHeader.forEach((keyword) => {
				keywordHeaderObj[keyword] = "SERP\n (" + keyword + ")";
			});

			let header_names = [
				{
					project_name: "Nom du projet",
					se_country: "Pays",
					se_language: "Langue",
					se: "Moteur de recherche",
					url: "url",
					domain_authority: "DA",
					// page_authority: "PA",
					referring_domains: "Domaines référents",
					external_links: "Liens entrants",
					anomaly: "Index d'URL \n Index d'URL Google",
					high_issues: "High Issues",
					// trust_flow: "Trust flow",
					// ttf0_name: "Nom TTF0",
					// ttf0_value: "Valeur TTF0",
					// ttf1_name: "Nom TTF1",
					// ttf1_value: "Valeur TTF1",
					// ttf2_name: "Nom TTF2",
					// ttf2_value: "Valeur TTF2",
					lighthouse_performance: "Performance",
					lighthouse_seo: "SEO",
					linkedin_url: "Linkedin",
				},
			];
			// adding additional keywords to report header
			header_names[0] = { ...header_names[0], ...keywordHeaderObj };
			let keywordDataObj = {};
			let formated_data = [];

			for (let i = 0; i < data.length; i++) {
				this.keywordsHeader.forEach((keyword) => {
					keywordDataObj[keyword] = data[i].keywords.find(
						(k) => k.keyword.toLowerCase() === keyword.toLowerCase()
					)
						? data[i].keywords.find(
								(k) => k.keyword.toLowerCase() === keyword.toLowerCase()
						  ).rank_absolute
						: "-";
				});
				let otherDataObj = {
					project_name: this.prospectProjectDetails.name || "-",
					se_country: this.prospectProjectDetails.country || "-",
					se_language: this.prospectProjectDetails.language || "-",
					se: this.prospectProjectDetails.search_engine || "-",
					url: data[i].url || "-",
					domain_authority: data[i].domain_authority || "-",
					external_links: data[i].external_links || "-",
					anomaly:
						data[i].total_internal_indexable_urls == 0
							? `0/${data[i].google_indexable_urls}`
							: `${Number(data[i].total_internal_indexable_urls)} / ${
									data[i].google_indexable_urls
							  }`,

					high_issues: data[i].highIssues || "-",
					// page_authority: data[i].page_authority,
					referring_domains: data[i].referring_domains,
					// referring_links: data[i].referring_links,
					// trust_flow: data[i].trust_flow,
					// ttf0_name: data[i].ttf0_name,
					// ttf0_value: data[i].ttf0_value,
					// ttf1_name: data[i].ttf1_name,
					// ttf1_value: data[i].ttf1_value,
					// ttf2_name: data[i].ttf2_name,
					// ttf2_value: data[i].ttf2_value,
					lighthouse_performance: data[i].performance * 100 || "-",
					lighthouse_seo: data[i].seo * 100 || "-",
					linkedin_url: data[i].linkedin_url || "-",
				};
				formated_data.push({
					...otherDataObj,
					...keywordDataObj,
				});
			}

			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, formated_data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Prospects_export.xls");
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayIssuesDetails(pid, url) {
			let ComponentClass = Vue.extend(SFIssuesDetailsPopUp);
			let sfIssuesPoup = new ComponentClass({
				propsData: {
					popupActive: true,
					prsopect_id: pid,
					prospect_url: url,
				},
			});
			sfIssuesPoup.$mount();

			this.$refs.popupContainer.appendChild(sfIssuesPoup.$el);
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayTechnologies(pid, url) {
			let ComponentClass = Vue.extend(PropsectTechnologyPopup);
			let technologiesPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					prsopect_id: pid,
					prospect_url: url,
				},
			});
			technologiesPopup.$mount();

			this.$refs.popupContainer.appendChild(technologiesPopup.$el);
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayLinkedinInfo(pid, url) {
			let ComponentClass = Vue.extend(LinkedinInfoPopup);
			let technologiesPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					prospectId: pid,
					prospect_url: url,
				},
			});
			technologiesPopup.$mount();

			this.$refs.popupContainer.appendChild(technologiesPopup.$el);
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayGtmetrixPopup(data) {
			let ComponentClass = Vue.extend(ProspectGTMetrixPopup);
			let gtMetrixPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					gtMetrixData: data,
				},
			});
			gtMetrixPopup.$mount();

			this.$refs.popupContainer.appendChild(gtMetrixPopup.$el);
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayRadarChart(pid, url) {
			let ComponentClass = Vue.extend(ProspectRadarChartPopup);
			let radarChartPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					prospectId: pid,
					prospect_url: url,
				},
			});
			radarChartPopup.$mount();

			this.$refs.popupContainer.appendChild(radarChartPopup.$el);
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayInternalDetails(pid, url) {
			let ComponentClass = Vue.extend(SFInternalTabsDetailsPopup);
			let sfIssuesPoup = new ComponentClass({
				propsData: {
					popupActive: true,
					prsopect_id: pid,
					prospect_url: url,
				},
			});
			sfIssuesPoup.$mount();

			this.$refs.popupContainer.appendChild(sfIssuesPoup.$el);
		},
	},
};
</script>
<style scoped>
::v-deep(.ag-body-viewport.ag-layout-auto-height.ag-row-no-animation) {
	height: 50vh;
	overflow: scroll;
}
</style>

<style>
/* Headers */
.netlink-header {
	background-color: #6d9bf1; /* Adjust the background color as needed */
	justify-content: center;
	align-items: center;
	color: #fff;
}
.keywords-header {
	background-color: #f4a261; /* Adjust the background color as needed */

	justify-content: flex-start;
	align-items: center;
	color: #fff;
}
.indexation-header {
	background-color: #2a9d8f; /* Adjust the background color as needed */
	justify-content: flex-start;
	align-items: center;
	color: #fff;
}
.webprefs-header {
	background-color: #e76f51; /* Adjust the background color as needed */
	justify-content: center;
	align-items: center;
	color: #fff;
}
.tech-header {
	background-color: #264653; /* Adjust the background color as needed */
	justify-content: center;
	align-items: center;
	color: #fff;
}
.others-header {
	background-color: #e9c46a; /* Adjust the background color as needed */
	justify-content: center;
	align-items: center;
	color: #fff;
}

/* Add vertical borders between top-level headers */
.ag-header-cell-label .ag-header-cell-text {
	white-space: normal; /* Allows text wrapping */
	word-wrap: break-word; /* Ensures long text can wrap properly */
	line-height: 1.5; /* Adjust line spacing for readability */
	text-align: center; /* Center the header text */
}
/* Center align the "Netlink" header specifically */
.ag-header-group-cell-label {
	text-align: center;
	justify-content: center;
}

/* Add this CSS in your component or global styles */
.seprator-header {
	border-left: 2px solid #ccc; /* Adjust the separator style */
	padding-bottom: 10px; /* Add space between the header and separator */
}
/* Add this CSS in your component or global styles */
.seprator-small-header {
	border-left: 2px solid #ccc; /* Adjust the separator style */
	padding-bottom: 10px; /* Add space between the header and separator */
}

.multi-line-header {
	white-space: normal; /* Allows text wrapping */
	word-wrap: break-word; /* Ensures long text can wrap properly */
	line-height: 1.5; /* Adjust line spacing for readability */
	text-align: center; /* Center the header text */
}
.inactive-row {
	background-color: rgba(
		180,
		180,
		180,
		0.9
	); /* Adjust the opacity and color as needed */
	filter: blur(
		4px
	); /* Adjust the blur amount as needed */ /* Adjust the opacity and color as needed */
}
.tooltip {
	position: relative;
	cursor: pointer;
}

.tooltip::after {
	content: attr(data-tooltip);
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%);
	padding: 0.5em;
	background-color: #333;
	color: #fff;
	border-radius: 4px;
	opacity: 0;
	transition: opacity 0.3s ease-in-out;
	pointer-events: none;
}

.tooltip:hover::after {
	opacity: 1;
}

.sloader {
	border: 5px solid #08b0b9;
	border-bottom-color: transparent;
	border-radius: 50%;
	display: inline-block;
	box-sizing: border-box;
	animation: rotation 1s linear infinite;
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

/* Your component styles here */
</style>